import AvgAckTimeWidget from './AvgAckTimeWidget';

export { AvgAckTimeWidget };
export default AvgAckTimeWidget;
